<template>
<form class="item-editor-form">
    <validation-provider v-slot="{ errors }" vid="id" rules="max:19"> <!-- Error doesn't appear on equal value so must be 19 -->
      <fg-input 
        v-model="form.id" 
        :label="$t('timetables.id')" 
        :disabled="action === 'item' || loading"
        maxlength="20"
      >
      </fg-input>
      <span v-if="errors.length" class="error-message">{{ $t('nav.timetables.idfield_maxlength') }}</span>
    </validation-provider>
    <fg-input v-model="form.name" :label="$t('timetables.name')" :disabled="loading"></fg-input>

    <label for="organisaatio">{{ $t('timetables.organisation') }}</label>
    <OrganisationSelect v-model="form.organisation" id="organisaatio"/>

    <!--
    <FormButtons
        @submit="submit" 
        :submit="$UIPrivilegeU('content/timetables')"  
        :reset="false" 
        :remove="action == 'item' && $UIPrivilegeD('content/timetables')" 
        @remove="remove"
        :disableSubmit="loading"
        :disableRemove="loading" />
    -->
    <t-button-group>
        <t-button v-if="$UIPrivilegeU('content/timetables')" type="save" @click="save" :disabled="loading"></t-button> 
        <t-button v-if="$UIPrivilegeD('content/timetables')" type="rm" @click="remove" :disabled="loading" style='float:right'></t-button> 
    </t-button-group>

    <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    <DeleteModal :id="item ? item.id : ''" @ok="onDeleteOK" />
</form>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
    ValidationProvider
  },
    props: {
        item: { default: null },
        action: { default: "new" }
    },
    data(){
        return  {
            form: {
                id: null,
                name: null,
                organisation: null
            },
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },
    watch: {
        item(){
          this.copyItemData();
        }
    },
    created(){
        this.copyItemData();
    },
    methods: {
        copyItemData(){
            if(this.item){
                this.form.id = this.item.id;
                this.form.name = this.item.name;
                this.form.organisation = this.item.organisation;
            }
        },
        save(){
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            setTimeout(() => { 
                this.$store.dispatch('timetableview/save', this.form).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                    //this.loading = this.disabled = false;
                    this.$emit('saved', this.form);
                })
                .catch( () => { this.error = true; }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        },
        remove(){
            this.$bvModal.show('delete-modal')
        },
        onDeleteOK() {
            this.infoType = "delete";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('timetableview/delete', this.item.id).then(response => {
                    this.$root.$emit('removedTimetable'); //this emit is used through root, because without it it doesn't work (probably because of modal)
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                }) 
                .catch( () => { this.error = true; }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        }
    }

}
</script>

  
